<!--Button Component - 1.0.0
    Created : 10-SEP-2019
    Created By : SPR/860
    Modified : 10-SEP-2019
    Dependencies: VUE JS
    Use : The v-icon component provides a large set of glyphs to provide context to various aspects of application. 
          For a list of all available icons, visit the official Material Design Icons page. 
          To use any of these icons simply use the mdi- prefix followed by the icon name.. -->
<template>
    <div class="header-button-panel">
        <!--Buttons/Icons For Form Components -->
        <v-icon style="font-size: 22px;border-radius:100px !important" v-if="card.type == 'Form' && disabled && showInputs && hideButtons.indexOf('Edit') == -1" @click="_btnEdit" small class="mr-2 vue-marterial-icon vue-marterial-edit-icon" v-bind:class="{'workflow': (workflow.workflowImplemented == true), 'title-search-enabled': (titleSearch == true)}" :title="$t(messages.edit)">mdi-pencil</v-icon>
        <v-icon style="font-size: 22px;border-radius:100px !important" v-if="card.type == 'Form' && !disabled && showInputs && hideButtons.indexOf('Close') == -1" @click="_btnCancel" small class="mr-2 vue-marterial-icon vue-marterial-cancel-icon" v-bind:class="{'workflow': (workflow.workflowImplemented == true), 'title-search-enabled': (titleSearch == true)}" :title="$t(messages.cancel)">mdi-close</v-icon>
        <v-icon style="font-size: 22px;border-radius:100px !important" v-if="card.type == 'Form' && !disabled && showInputs && permissions.indexOf('E') != -1 && hideButtons.indexOf('Edit') == -1" @click="_btnSave" :title="$t(messages.save)" small class="mr-2 vue-marterial-icon vue-marterial-save-icon" v-bind:class="{'workflow': (workflow.workflowImplemented == true), 'title-search-enabled': (titleSearch == true)}" :disabled="buttonDisabled">mdi-content-save </v-icon>

        <!--Buttons/divider/overlay For Grid Components -->
        <router-link v-if="permissions.indexOf('A') != -1 && (card.type == 'Grid' || card.type == 'TreeTable') && hideButtons.indexOf('Add') == -1 && !inlineEditor.emptyRow && redirect != null" @click.native="_btnRouterLink" class="router-link" :to="{ path: (redirect.action + '?mId=' + redirect.menuId + '#0')}">
            <v-icon style="font-size: 24px;margin-top:-13px;border-radius:100px !important" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" :title="$t(messages.add)">mdi-plus</v-icon>
        </router-link>
        <v-icon style="font-size: 24px;margin-top:-13px;border-radius:100px !important" v-if="permissions.indexOf('A') != -1 && (card.type == 'Grid' || card.type == 'TreeTable') && rowMenuButtons.enabled != true && hideButtons.indexOf('Add') == -1 && !inlineEditor.emptyRow && redirect == null || (permissions.indexOf('A') != -1 && card.type == 'FormLabelLeft' && formData.length == 0)" v-bind:class="{ 'Form-label-left': (permissions.indexOf('A') != -1 && card.type == 'FormLabelLeft' && formData.length == 0)}" @click="_btnAdd" small class="mr-2 vue-marterial-icon vue-marterial-add-icon" :title="$t(messages.add)">mdi-plus</v-icon>
        <v-divider v-if="(card.type == 'Grid' || card.type == 'TreeTable') && simpleSearch == true && permissions.indexOf('A') != -1 && rowMenuButtons.enabled != true && hideButtons.indexOf('Add') == -1" class="mx-3" inset vertical></v-divider>

        <!--Progress Component-->
        <v-progress-circular v-if="progress && card.type == 'Grid' && exportOption.enabled == true" indeterminate color="primary"></v-progress-circular>

         <!--Generic Import Component-->
         <v-icon v-if="card.type == 'Grid' && importOption.enabled == true && accessDeny != true"  @click="onButtonClick" :title="messages.import">mdi-import</v-icon>
          <input
            ref="uploader"
            class="d-none"
            type="file"
            accept="*"
            @change="onAddFiles"
        >

        <!--Generic Export Component-->
        <v-icon v-if="(card.type == 'Grid' || card.type == 'TreeTable') && exportOption.enabled == true && accessDeny != true" @click="_btnExport" :title="messages.export">mdi-export</v-icon>

        <!--Grouping Option-->
        <v-divider v-if="grouping.enabled && grouping.defaultGroupBy.length != 0" class="mx-3" inset vertical></v-divider>
        <v-icon v-if="grouping.enabled && grouping.collapse && grouping.defaultGroupBy.length != 0" @click="_btnGrouping('_exp')" small class="mr-2 vue-marterial-icon vue-marterial-grouping-icon" :title="$t(messages.expand)"> mdi-arrow-expand </v-icon>
        <v-icon v-if="grouping.enabled && !grouping.collapse && grouping.defaultGroupBy.length != 0" @click="_btnGrouping('_col')" small class="mr-2 vue-marterial-icon vue-marterial-grouping-icon" :title="$t(messages.collapse)"> mdi-arrow-collapse </v-icon>

        <!--Tree Table Option-->
        <v-divider v-if="card.type == 'TreeTable' && exportOption.enabled == true && accessDeny != true" class="mx-3" inset vertical></v-divider>
        <v-icon v-if="card.type == 'TreeTable' && treeTable.collapse" @click="_btnTreeExpand('_exp')" small class="mr-2 vue-marterial-icon vue-marterial-grouping-icon" :title="$t(messages.expand)"> mdi-arrow-expand </v-icon>
        <v-icon v-if="card.type == 'TreeTable' && !treeTable.collapse" @click.native="_btnTreeExpand('_col')" ref="collapseBtn" small class="mr-2 vue-marterial-icon vue-marterial-grouping-icon" :title="$t(messages.collapse)"> mdi-arrow-collapse</v-icon>
        <v-divider v-if="card.type == 'TreeTable' && simpleSearch == true" class="mx-3" inset vertical></v-divider>

        <!--Export Option-->
        <v-divider v-if="card.type == 'Grid' && exportOption.enabled == true && accessDeny != true" class="mx-3" inset vertical></v-divider>
        <v-overlay :value="dialog"></v-overlay>
    </div>
</template>

<script>
    import moment from 'moment';
    import * as _ from 'lodash';
    import XLSX from 'xlsx';
    import { AppConstants as _app } from "@/shared/app.constants";

    export default {
        // components: {
        //     XLSX
        // },

        /*
            *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
            *  this.$options.parent.fileName - current componets name
        */
        data() {
            return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
        },

        /*
            * The mounted() method gives you access to templates and enables interaction with the DOM.
        */
        mounted() {
            // @ts-ignore
            let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
           
            if (context.card.type == context.type._treeTable && !context.treeTable.collapse && this.$refs.collapseBtn) {
                this.collapse = true;
                setTimeout(() => {
                    // @ts-ignore
                    this.$refs.collapseBtn.$el.click();
                    this.collapse = false;
                }, 1000);
            }
        },

        /*
            * Define methods under the `methods` object
            * _btnSave - Saves editing form to the server and updates the record on the table.
            * _btnAdd - Shows add form for a grid card component
            * _btnEdit - Shows edit form for a form card component
            * _btnCancel - Reset field component values
            * _btnSetFocusOnElement - Set focus on first editable field
        */
        methods: {
            /*
                * Export button click event
            */
            _btnExport() {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName],
                    exportableData = [], filterRecords = [], exportRecordIndex = [],
                    self = this;
                     
                //#.Checking empty data
                if ((context.formData.length == 0 || (context.inlineEditor.enabled && context.inlineEditor.emptyRow && context.formData.length == 1)) || (context.lazyLoading && context.lazyLoading.enabled && context.lazyRecords.length == 0)) {
                    this.$store.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.noData });
                    return;
                }

                //#.Checking for tree table components
                if (context.card.type == context.type._treeTable) {
                   
                    //#.Exportable data set
                    for (var i = 0; i < context.formData.length; i++) {
                        exportableData[exportableData.length] = {};

                        for (var j = 0; j < context.headers.length; j++) {
                            let x = context.headers[j];

                            //#.Export fieldset
                            if (x.type != 'Hidden' && x.type != 'button' && x.type != 'Button' && x.password != true && x.primaryKey != true && x.parent != true && x.exportable != false) {
                                exportableData[exportableData.length - 1][x.text] = context.formData[i][x.value];
                               
                            }
                        }
                        //#.Recursive call()
                        this._exportDataRecurse(context.formData[i], exportableData);
                    }
                } else {
                    let records = context.formData;

                    if (context.lazyLoading && context.lazyLoading.enabled && context.pagination.pageSize == -1) {
                        records = context.lazyRecords;
                    }

                    _.forOwn(records, function (val, key) {
                        let values = val;
                        exportableData[key] = {};
                        context.fields.filter(x => x.type != 'Hidden' && x.type != 'button' && x.password != true && x.primaryKey != true && x.parent != true && x.exportable != false).forEach(record => {
                            exportableData[key][record.text] = values[record.value];

                            //#. Checking filter records
                            self._filter(values[record.value], key, exportRecordIndex);
                        });
                    });
                }

                if (context.inlineEditor.enabled && context.inlineEditor.emptyRow == true) {
                    exportableData = exportableData.slice(0, -1);
                }

                //#. Filter final records
                if(context.filterableData) {
                    _.forOwn(exportRecordIndex, function (i, value) {
                        filterRecords.push(exportableData[exportRecordIndex[value]])
                    });
                }
                
                //#.Export json to Worksheet of Excel
                if(context.filterableData) {
                    var sheet1 = XLSX.utils.json_to_sheet(filterRecords);
                }
                else {
                    var sheet1 = XLSX.utils.json_to_sheet(exportableData);
                }

                //#.A workbook is the name given to an Excel file
                var wb = XLSX.utils.book_new() // make Workbook of Excel

                if (context.title && context.title.indexOf("/") != -1) {
                    //#.Add Worksheet to Workbook. Workbook contains one or more worksheets (sheetAName is name of Worksheet)
                    XLSX.utils.book_append_sheet(wb, sheet1, context.title.replace("/", ""))

                    //#.Export Excel file
                    XLSX.writeFile(wb, context.title.replace("/", "") + '.xlsx')

                    return;
                }

                //#.Add Worksheet to Workbook. Workbook contains one or more worksheets (sheetAName is name of Worksheet)
                XLSX.utils.book_append_sheet(wb, sheet1, context.title)

                // #.Export Excel file
                XLSX.writeFile(wb, context.title + '.xlsx')
            },

            onAddFiles(e)
            {
                let files = e.target.files[0];
                const { name, type, size } = files;
                this._btnImport(files)
            },

            onButtonClick() {
                this.$refs.uploader.click();
            },

            _btnImport(e)
            {
              let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName]
              let formData = new FormData();
              formData.append("file", e);
              this.$store.dispatch(context.fileName + '/' + context.importOption.actionName, { formData:formData,context:context, self:this });
              //@ts-ignore
              this.$refs.uploader.value = null;
            },
            
            /*
                * Filter method
            */
            _filter(val, index, exportRecordIndex) {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                if(context.filterableData == false) {
                    return;
                }

                index = parseInt(index);

                //#.In case of number fields.
                if (typeof val == "number") {
                    val = val.toString();
                }

                if(val && val.toLowerCase().includes((context.filterableText ?? "").toLowerCase())) {
                    if (!exportRecordIndex.includes(index)) {
                        exportRecordIndex.push(index);
                    }
                }
            },

            /*
                * Tree table export method
            */
            _exportDataRecurse(formData, exportableData) {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                if (formData && formData._children) {
                    for (var i = 0, l = formData._children.length; i < l; ++i) {
                        exportableData[exportableData.length] = {};

                        for (var j = 0; j < context.headers.length; j++) {
                            let x = context.headers[j];
                            //#.Export fieldset
                            if (x.type != 'Hidden' && x.type != 'button' && x.type != 'Button' && x.password != true && x.primaryKey != true && x.parent != true && x.exportable != false) {
                                exportableData[exportableData.length - 1][x.text] = formData._children[i][x.value];
                            }
                        }

                        //#.Recursive call()
                        this._exportDataRecurse(formData._children[i], exportableData);
                    }
                }
            },

            /*
                * Card Type: Form - Saves editing form to the server and updates the record on the table.
                * item (edit object) - Forenkey not convert to id 
                * record (server object) - Forenkey convert to id
            */
            _btnSave() {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName],
                    updateActions = context.actions.updateAction,
                    createActions = context.actions.createAction,
                    item = context.editedItem,
                    root = this.$store.state,
                    self = this,
                    record = {};

                if (!context.parentComponent && context.dashboard.componentId == 0) {
                    //#.Enable notify are triggered with the store.dispatch method.
                    this.$store.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.cardFill });
                    return;
                }

                //#. Check for workflow implementation
                if (context.dashboard.componentId != 0 && context.workflow.workflowImplemented) {
                    if (context.editedItem[context.workflow.workflowStepId] != null && typeof (context.editedItem[context.workflow.workflowStepId]) == 'object') {
                        item[context.workflow.workflowStepId] = context.editedItem[context.workflow.workflowStepId].Value;                
                    } else if (context.editedItem[context.workflow.workflowStepId] != null && isNaN(context.editedItem[context.workflow.workflowStepId])) {
                        let workflowOptions = context.workflow.optionsList.find(x => x.DisplayText.toLowerCase() == context.editedItem[context.workflow.workflowStepId].toLowerCase());
                        
                        if(workflowOptions){
                            item[context.workflow.workflowStepId] = workflowOptions.Value;
                        }
                    } else if (context.editedItem[context.workflow.workflowStepId] != null && !isNaN(context.editedItem[context.workflow.workflowStepId])) {
                        let workflowOptions = context.workflow.optionsList.find(x => x.Value == context.editedItem[context.workflow.workflowStepId]);
                        
                        if(workflowOptions){
                            item[context.workflow.workflowStepId] = workflowOptions.Value;
                        }
                    }
                }

                //#.Disable the enabled save button
                context.buttonDisabled = true;

                //#.Assigning title value to the title serach field. 
                if (context.titleSearch) {
                    let fieldName = context.orginTitle.substr(2).slice(0, -2);
                    context.editedItem[fieldName] = context.title;
                }

                //#.Update form data object
                if (!context.ajaxFormSubmit) {
                    item["FormData"] = context.editedItem["FormData"] || new FormData();
                }

                //#.Fetch primary key field
                let keyField = context.fields.filter(x => x.primaryKey == true).find(x => x).value;

                //#.Fetch image input values
                context.fields.filter(x => x.type == 'ImageInput').forEach(key => {
                    record[key.value] = item[key.value];

                    if ((record[key.value] == "" || record[key.value] == null) && key.required) {
                        item[key.value] = undefined;
                        record[key.value] = undefined;
                    } else if (record[key.value] == "") {
                        record[key.value] = null;
                        item[key.value] = null;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {

                        if (record[key.value] == null)
                            context.editedItem["FormData"] = new FormData();

                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Masked false to the server and updates the record on the table.e
                context.fields.filter(x => x.mask && x.mask.enabled == true).forEach(key => {
                    if (item[key.value])
                        record[key.value] = (item[key.value]).toString().replace(/\D+/g, '');
                });

                //#.Fetch foreign key field values with single value
                context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                    record[key.value] = item[key.value];

                    if (record[key.value] != null && typeof (record[key.value]) == 'object')
                        record[key.value] = record[key.value].Value
                    else if (record[key.value] != null && key.value != 'WorkFlowStatusId')
                        record[key.value] = key.select.Value;

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Fetch foreign key field values with multi value
                context.fields.filter(x => x.type == 'CheckboxList').forEach(key => {
                    record[key.value] = item[key.value];

                    if (!record[key.value])
                        return;

                    if (record[key.value].length == 0) {
                        record[key.value] = null;
                        item[key.value] = null;
                        return;
                    }

                    record[key.value] = record[key.value].toString();

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Fetch number input values
                context.fields.filter(x => x.type == 'Number').forEach(key => {

                    if(key.currency && key.currency.enabled) {
                        record[key.value] = (item[key.value] + '').replace(new RegExp('\\' + _app.region.decimalSeparator), '.').replaceAll(_app.region.CurrencyGroupSeparator, '').replace(/\s+/g, "");
                    } else {
                        record[key.value] = item[key.value];
                    }
                   
                    //record[key.value] = item[key.value];
                    
                    if ((record[key.value] == "" || record[key.value] == null) && key.required) {
                        item[key.value] = undefined;
                        record[key.value] = undefined;
                    } else if (record[key.value] == "") {
                        record[key.value] = null;
                        item[key.value] = null;
                    }     

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Fetch Switch input values
                context.fields.filter(x => x.type == 'SwitchInput').forEach(key => {
                    record[key.value] = item[key.value];

                    if (record[key.value] == true || record[key.value] == 1) {
                        item[key.value] = 1;
                        record[key.value] = 1;
                    } else {
                        record[key.value] = 0;
                        item[key.value] = 0;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Fetch foreign key field values with multi value
                context.fields.filter(x => x.type == 'MultiSelect').forEach(key => {
                    record[key.value] = item[key.value];

                    if (!record[key.value])
                        return;

                    if (record[key.value].length == 0) {
                        record[key.value] = null;
                        item[key.value] = null;
                        return;
                    }

                    if (typeof (record[key.value]) == 'object' && record[key.value].length > 0) {
                        let value = [];

                        record[key.value].filter(x => x.id).forEach(key => {
                            value.push(key.id);
                        });

                        record[key.value].filter(x => x.Value).forEach(key => {
                            value.push(key.Value);
                        });

                        record[key.value] = value.join();
                        return;
                    }
                });

                //#.Fetch date value based on the settings
                context.fields.filter(x => x.type == 'Date').forEach(key => {
                    record[key.value] = item[key.value];

                    if (!item[key.value]) {
                        record[key.value] = null;

                        //# Issue with  not nullable Date field
                        if (item[key.value] == "" && key.required) {
                            item[key.value] = undefined;
                        }

                        return;
                    }

                    if (key.displayFormat && key.displayFormat.toLowerCase().indexOf('y') > 0)
                        record[key.value] = moment(key.date, key.displayFormat).format('YYYY-MM-DD');
                    else if (key.displayFormat && key.displayFormat.toLowerCase().indexOf('y') < 0)
                         record[key.value] = moment(key.date, context.defaultDateFormat).format('YYYY-MM-DD');
                    else
                        record[key.value] = moment(item[key.value], context.defaultDateFormat).format('YYYY-MM-DD');

                    if (record[key.value] == 'Invalid date') {
                        record[key.value] = null;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                });

                //#.Fetch foreign key(parent) field values with single value
                context.fields.filter(x => x.parent == true).forEach(key => {
                    record[key.value] = context.dashboard.componentId;
                });

                //#.Added hiden/primaryKey/foreignKey fields values in new object
                _.forOwn(item, function (val, key) {
                    if (!record[key] && typeof (val) != 'object' && record[key] != 0) {
                        record[key] = val;

                        //#.Check form action be direct form submit or not
                        if (!context.ajaxFormSubmit) {
                            self._dtFormSubmit(context, key, record);
                        }
                    }
                });

                //#.Check if the componet is add / edit form
                if (context.dashboard.componentId == 0) {
                    record[keyField] = 0;

                    //#.Assigning title value to the title serach field. 
                    if (context.titleSearch) {
                        let fieldName = context.orginTitle.substr(2).slice(0, -2);
                        record[fieldName] = context.title;
                    }

                    //#.Before Create action are triggered with the store.dispatch method.
                    this.$store.dispatch(context.fileName + '/beforeCreated', { context: context, record: record });

                    //#.Create action are triggered with the store.dispatch method.
                    this.$store.dispatch('Create', { record, keyField, createActions, context, root, self });
                    return;
                }

                //#.Before Create action are triggered with the store.dispatch method.
                this.$store.dispatch(context.fileName + '/beforeUpdated', { context: context, record: record });
                //#.Update action are triggered with the store.dispatch method.
                if (context.isInUse)
                    this.$store.dispatch('dashboard/enableNotify', { color: 'confirm', text: context.messages.callIsInUse, record: record, name: (this.$options.parent.fileName || this.$options.parent.$parent.fileName), type: 'save' });
                else
                    this.$store.dispatch('Update', { record, updateActions, context, self });
            },

            /*
                * Override the create new record submit method
                * Direct form submit for file upload added  
            */
            _dtFormSubmit(context, key, record) {
                if (!context.editedItem["FormData"])
                    context.editedItem["FormData"] = new FormData();

                if (record[key.value])
                    context.editedItem["FormData"].append(key.value, record[key.value]);
                else if (record[key])
                    context.editedItem["FormData"].append(key, record[key]);
            },

            /*
                * Card Type: redirect to the child component (add form)
            */
            _btnRouterLink() {
                let context = this.$store.state.dashboard;

                //#.Update component id.
                context.componentId = 0;

                //#.Add form are triggered with the store.dispatch method.
                this.$store.dispatch('dashboard/getTemplate', { context: context, lang: this.$vuetify.lang });
            },

            /*
                * Card Type: Shows add form for a grid card component
            */
            _btnAdd() {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                if (context.inlineEditor.enabled && context.inlineEditor.emptyRow == false && context.filterableData) {
                    this.$store.dispatch('dashboard/enableNotify', { color: 'error', text: context.messages.clear });
                    return;
                }

                //#.Add form are triggered with the store.dispatch method.
                this.$store.dispatch('dashboard/add', { context: context, self: this });
            },

            /*
                * Card Type: Form - Shows edit form for a form card component
            */
            _btnEdit() {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                //#.Enable title search are triggered with the store.dispatch method.
                this.$store.dispatch('dashboard/edit', context);
                //#.formCreated event raising methods
                this.$store.dispatch(context.fileName + '/formCreated', context);
            },

            /*
                * Card Type: Form - Will only reset changed input values and not alter their state
            */
            _btnCancel() {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
                //#.Remove form edit are triggered with the store.dispatch method.
                this.$store.dispatch('dashboard/removeEdit', { context: context, self: this });
                //#.formCancel event raising methods
                this.$store.dispatch(context.fileName + '/formCancel', context);
                //#.Remove changes
                context.isDirty = false;
            },

            /*
                * Grouping collapse and expand option
            */
            _btnGrouping(group) {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                //#. Expand option
                if (group == '_exp') {
                    for (var i = 0; i < context.formData.length; i++) {
                        context.formData[i]["hide"] = false;
                    }

                    context.grouping.collapse = false;
                    context.renderTable = false;

                    this.$nextTick(() => {
                        //#. Add the component back in
                        context.renderTable = true;
                    });

                    return;
                }

                //#. Collapse option
                for (var i = 0; i < context.formData.length; i++) {
                    context.formData[i]["hide"] = true;
                }

                context.grouping.collapse = true;
                context.renderTable = false;

                this.$nextTick(() => {
                    //#. Add the component back in
                    context.renderTable = true;
                });
            },

            /*
                * Tree Table collapse and expand option
            */
            _btnTreeExpand(group) {
                let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];

                //#.Checking initial loading
                if (this.collapse) {
                    group = '_exp';
                }

                //#. Expand option
                if (group == '_exp') {
                    for (var i = 0; i < context.formData.length; i++) {
                        context.formData[i]["_showChildren"] = true;
                        this._btnRecurseGrouping(context.formData[i], group)
                    }

                    context.treeTable.collapse = false;
                    context.renderTable = false;

                    this.$nextTick(() => {
                        //#. Add the component back in
                        context.renderTable = true;
                    });

                    return;
                }

                //#. Collapse option
                for (var i = 0; i < context.formData.length; i++) {
                    context.formData[i]["_showChildren"] = false;
                    this._btnRecurseGrouping(context.formData[i], group)
                }

                context.treeTable.collapse = true;
                context.renderTable = false;

                this.$nextTick(() => {
                    //#. Add the component back in
                    context.renderTable = true;
                });
            },

            /*
                * Tree Table collapse and expand option
            */
            _btnRecurseGrouping(parent, group) {
                //#. Expand option
                if (group == '_exp') {
                    if (parent && parent._children) {
                        for (var i = 0, l = parent._children.length; i < l; ++i) {
                            var child = parent._children[i];                             
                            child["_showChildren"] = true;
                            this._btnRecurseGrouping(child, group);                                      
                        }
                    }
                    return;
                }

                //#. Collapse option
                if (parent && parent._children) {
                    for (var i = 0, l = parent._children.length; i < l; ++i) {
                        var child = parent._children[i];                             
                        child["_showChildren"] = false;
                        this._btnRecurseGrouping(child, group);                                      
                    }
                }
            }
        }
    }
</script>
